module.exports = __webpack_public_path__ + "media/page-7.2f45bcf5.mp3";